import axios from "axios"
import {EmployeeCreate, EmployeeEdit} from "../redux/employees/employees.type";

/**
 * Get employees by workspace and client.
 *
 * @param uuid Workspace UUID
 * @param clientUuid Client UUID.
 */
async function getEmployeesApi(uuid: string, clientUuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees`
    });
}

/**
 * Create employee.
 *
 * @param uuid
 * @param clientUuid
 * @param data
 * @param authorization
 */
async function postEmployeeApi(uuid: string, clientUuid: string, data: EmployeeCreate, authorization: boolean) {
    const { first_name, last_name, position, status } = data;
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees`,
        data: {
            first_name, last_name, position, status, authorization
        }
    });
}

/**
 * Update employee.
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 * @param data
 */
async function patchEmployeeApi(uuid: string, clientUuid: string, employeeUuid: string, data: EmployeeEdit) {
    return axios({
        method: 'PATCH',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}`,
        data: data
    });
}

/**
 * Delete employee.
 *
 * @param uuid
 * @param clientUuid
 * @param employeeUuid
 */
async function deleteEmployeeApi(uuid: string, clientUuid: string, employeeUuid: string) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/employees/${employeeUuid}`,
    });
}

export {
    getEmployeesApi,
    deleteEmployeeApi,
    patchEmployeeApi,
    postEmployeeApi
}